const NavMenuNames = {
    Explorer: "Explorer",
    Leads:"Leads",
    Operations:"Operations"
};


export {
    NavMenuNames
};